import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FinancialAdvisorService {
  private trigger = new Subject<void>();
  public $triggerEvent = this.trigger.asObservable();

  showModel() {
    this.trigger.next();
  }
}
